import React, { useEffect, useState } from 'react';
import { Container, Tab, Tabs,TabContent  } from "react-bootstrap";
import {
  MainTabSection, 
} from './tabStyle'
import BoardMembers from '../../../pages/aboutUs/members/boardMembers';
import AdvisoryBoard from '../../../pages/aboutUs/members/advisoryBoard';
import TeamMembers from '../../../pages/aboutUs/members/teamMembers';
import { useLocation, useNavigate } from 'react-router-dom';

const TabSection = () => {
  const [key, setKey]= useState<string>('');
  const {pathname} = useLocation();
  const navigate = useNavigate()

  useEffect(() => {
    if(pathname){
      setKey(pathname)
    }
  }
  ,[pathname])

  return (
    <MainTabSection>  
      <Container>
        <Tabs defaultActiveKey="/about/team"  activeKey={key}
            onSelect={(eventKey:any) => navigate(eventKey)}
             className="responsive-tabs" fill>
          <Tab eventKey="/about/board-members" title="Board Members">
            <TabContent><BoardMembers /></TabContent>
          </Tab>
          <Tab eventKey="/about/team" title="Team Members">
            <TabContent><TeamMembers /></TabContent>
          </Tab>
          <Tab eventKey="/about/advisory-board" title="Advisory Board">
            <TabContent><AdvisoryBoard /></TabContent>
          </Tab>
        </Tabs>
      </Container>
    </MainTabSection>
  )
}

export default TabSection
